/**
 * App specific overrides
 * @param {} theme
 */
export const getBaselineOverrides = theme => ({
  styleOverrides: {
    'html, body': {
      fontFamily: theme.typography.fontFamily,
      height: '100%',
      backgroundColor: theme.palette.paper,
    },
    '#pl-root': {
      height: '100%',
      width: '100%',
    },
    // style for shift-drag-zoom
    '.ol-box': {
      background: theme.palette.common.white,
      border: `1px dashed ${theme.palette.primary.dark}`,
      boxSizing: 'border-box',
      opacity: 0.4,
    },
    a: {
      cursor: 'pointer',
    },
    img: {
      userDrag: 'none',
    },
    '.intercom-launcher-frame': {
      display: 'none !important',
    },
    '.sentry-error-embed-wrapper': {
      '& .btn': {
        background: `${theme.palette.primary.main} !important`,
        border: `1px solid ${theme.palette.primary.main} !important`,
        borderRadius: theme.shape.borderRadius,
      },
    },
  },
});

/**
 * Global and Material-UI overrides based on designs and pairing
 * We use the theme as a param to make the switch between dark and light easier
 * @param {*} theme - theme to be used as baseline
 */
export const getStyleOverrides = theme => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: theme.palette.grey[500],
        },
      },
    },
    MuiLink: {
      defaultProps: {
        variant: 'inherit',
        underline: 'hover',
      },
    },
    MuiSlider: {
      styleOverrides: {
        markLabel: {
          top: 20,
        },
      },
    },
    MuiChip: {
      defaultProps: {
        size: 'small',
        shape: 'square',
        variant: 'light',
      },
      styleOverrides: {
        icon: ({ownerState, theme}) => ({
          marginRight: ownerState.label
            ? theme.spacing(-0.5)
            : theme.spacing(0.5),
        }),
        label: ({ownerState, theme}) => ({
          paddingRight: ownerState.label ? theme.spacing(1) : 0,
          paddingLeft: ownerState.label ? theme.spacing(1) : 0,
        }),
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track': {
            opacity: 1,
          },
        },
      },
    },
    // reset to Mui defaults
    MuiButton: {
      styleOverrides: {
        sizeLarge: {
          fontSize: theme.typography.pxToRem(16),
          padding: theme.spacing(1, 2.75),
        },
        sizeSmall: {
          fontSize: theme.typography.pxToRem(13),
          padding: theme.spacing(0.5, 1.25),
        },
      },
    },
    MuiIconButton: {
      variants: [
        {
          props: {shape: 'square'},
          style: {
            borderRadius: theme.shape.borderRadius,
          },
        },
      ],
    },
  };
};
